var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.row)?_c('div',[(_vm.hasSample)?_c('span',{on:{"click":_vm.deleteSample}},[_c('i',{staticClass:"fal fa-check-square text-success fa-2x pointer"})]):_c('span',{on:{"click":_vm.addSample}},[_c('i',{staticClass:"fal fa-square text-success fa-2x pointer"})])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }